type DebugLevel = "info" | "warn" | "error";

const TRACE_ID_KEY = "dim_client_trace_id";
const DEBUG_FLAG_KEY = "dim_client_debug";

function getConsoleMethod(level: DebugLevel) {
  if (level === "warn") return console.warn;
  if (level === "error") return console.error;
  return console.info;
}

function createTraceId(): string {
  return `cd-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function isClientDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;

  const envEnabled = process.env.NEXT_PUBLIC_CLIENT_DEBUG === "true";
  const localEnabled = window.localStorage.getItem(DEBUG_FLAG_KEY) === "1";
  const queryEnabled = new URLSearchParams(window.location.search).has("debugClients");

  return envEnabled || localEnabled || queryEnabled;
}

export function getClientTraceId(): string {
  if (typeof window === "undefined") return "server";

  let traceId = window.sessionStorage.getItem(TRACE_ID_KEY);
  if (!traceId) {
    traceId = createTraceId();
    window.sessionStorage.setItem(TRACE_ID_KEY, traceId);
  }
  return traceId;
}

export function clientDebugLog(
  event: string,
  payload: Record<string, unknown> = {},
  level: DebugLevel = "info"
): void {
  if (!isClientDebugEnabled() || typeof window === "undefined") return;

  const log = getConsoleMethod(level);
  log("[DIM_CLIENT_DEBUG]", {
    event,
    traceId: getClientTraceId(),
    path: window.location.pathname,
    ts: new Date().toISOString(),
    ...payload,
  });
}
